import _sfc_main from "./component-library216.mjs";
import "./component-library217.mjs";
import normalizeComponent from "./component-library92.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.LinkButton, { staticClass: "dropdown-item", attrs: { "role": "option", "tag": _setup.hasLink ? "a" : "span", "href": _setup.hasLink ? _vm.url : void 0, "transparent": "", "is-external": false, "aria-selected": _vm.selected ? "true" : "false", "small-padding": "", "tabindex": "0", "title": _vm.label, "disabled": _vm.disabled }, nativeOn: { "keydown": [function($event) {
    if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter"))
      return null;
    return _setup.onClick.apply(null, arguments);
  }, function($event) {
    if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"]))
      return null;
    return _setup.onClick.apply(null, arguments);
  }], "click": function($event) {
    return _setup.onClick.apply(null, arguments);
  } } }, [_c(_setup.DropdownItemContent, { attrs: { "count": _vm.count, "label": _vm.label, "selected": _vm.selected }, scopedSlots: _vm._u([{ key: "before", fn: function() {
    return [_vm._t("beforeLabel", null, { "value": _vm.value })];
  }, proxy: true }], null, true) })], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "cc3edde3",
  null,
  null
);
const DropdownItem = __component__.exports;
export {
  DropdownItem as default
};
